import { render } from "./CadastroTipoDocumentoView.vue?vue&type=template&id=6c5710d9"
import script from "./CadastroTipoDocumentoView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoDocumentoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__